import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Box,
  Button,
  HStack,
} from '@chakra-ui/react';

export default function InvoicePdfPreviewModal({
  isOpen,
  onClose,
  blobUrl,
  title,
  onDownload,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="90vh">
        <ModalHeader fontSize="md" pr={12}>
          {title || 'Vista previa de factura'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <HStack justify="flex-end" mb={3} spacing={2}>
            {onDownload && (
              <Button size="sm" variant="adminPrimary" onClick={onDownload}>
                Descargar PDF
              </Button>
            )}
          </HStack>
          {blobUrl ? (
            <Box
              as="iframe"
              src={blobUrl}
              title={title || 'Vista previa PDF'}
              w="100%"
              h={{ base: '60vh', md: '70vh' }}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="md"
            />
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
